import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    OnChanges,
    SimpleChanges,
} from "@angular/core";
import { Observable, Subject, Subscriber } from "rxjs";
import { switchMap, takeUntil } from "rxjs/operators";
import { NbcBaseComponent } from "../../../core/component/Base.Component";
import { EventBusService } from "../../../core/services/event-bus.service";
import { NbcLoggerService } from "../../../shared/logger/nbc-logger.service";
import { LookUpService } from "../../../shared/services/lookup.service";
import * as _ from "lodash";

@Component({
    selector: "glaccount",
    templateUrl: "./glaccount.component.html",
    standalone: false
})
export class GlAccountComponent
    extends NbcBaseComponent
    implements OnInit, OnChanges
{
    constructor(
        private lookupService: LookUpService,
        private _eventBus: EventBusService,
        private log: NbcLoggerService
    ) {
        super();
    }

    @Input() model: any | undefined;
    @Input() name: string | undefined;
    @Input() id: string | undefined;
    @Input() mpId: string | undefined;
    @Input() nbcClass: string | undefined;
    @Input() isRequired = false;
    @Input() placeHolder: any | undefined;
    @Input() typeaheadOptionLimit: any = 10;
    @Input() nbcAuthenticateUser: any | undefined;
    @Input() nbcAuthenticateCommand: any | undefined;
    @Input() nbcAuthenticateDisabled: any | undefined;
    @Input() nbcAuthenticateRequired: any | undefined;
    @Input() nbcDisabled: any | undefined;
    @Input() isBulkUpdate = false;

    @Output() modelChange = new EventEmitter<any>();
    @Output() glAccountChange: EventEmitter<any> = new EventEmitter<any>();

    isAuthorized = true;
    glAccountObservable$: Observable<any[]> | undefined;
    componentDestroyed$: Subject<any> = new Subject();

    searchTerm = "";
    
    getGLAccounts() {
        this.log.trace("get GL Account");
        this.glAccountObservable$ = new Observable(
            (observer: Subscriber<string>) => {
                observer.next(this.searchTerm);
            }
        ).pipe(
            takeUntil(this.componentDestroyed$),
            switchMap((token: string) => {
                return this.lookupService.searchGlAccounts(
                    encodeURIComponent(token)
                );
            })
        );
    }

    EmitModelData() {
        this.modelChange.emit(this.searchTerm);

        const data = {
            mpId: this.mpId,
            glAccount: this.searchTerm,
        };
        //this.glAccountChange.emit(data);
    }

    onValueSelected($event) {
        const glAccount = $event.item;
        this.modelChange.emit(glAccount);

        const data = {
            mpId: this.mpId,
            glAccount: glAccount,
        };
        this.glAccountChange.emit(data);
    }

    onBlur($event) {

        setTimeout(() => {
            if (
                _.isEmpty(this.searchTerm) ||
                (!_.isEmpty(this.searchTerm) &&
                    this.model &&
                    this.searchTerm.toLowerCase() !== this.model.toLowerCase())
            ) {
              this.modelChange.emit(null);
                return;
            }
            if (this.searchTerm?.toLowerCase() !== this.model?.toLowerCase()) {
                this.searchTerm = "";
              this.modelChange.emit(null);
            }
        }, 200);
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === "model") {
                const current = changes["model"]["currentValue"];
                const prev = changes["model"]["previousValue"];
                this.model = current;
              this.searchTerm = current;
            }
        }
    }

    ngOnInit() {
        this.searchTerm =_.cloneDeep(this.model);
        this.getGLAccounts();     

        if (!this.nbcDisabled)
            this.isAuthorized = this.authorize(this.nbcAuthenticateUser);
    }
}
